"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormHeroCheckboxOld", {
    enumerable: true,
    get: function() {
        return FormHeroCheckboxOld;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Theme = require("../../../contexts/Theme");
const _FormGroupContext = require("../../../contexts/FormGroupContext");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const FormHeroCheckboxOld = /*#__PURE__*/ _react.default.forwardRef((props, ref)=>{
    const { label, description, value: propsValue, onChange, children, ...inputProps } = props;
    const { colors, isAdmin, borderRadius, spacers } = (0, _Theme.useTheme)();
    const { id, hintId } = (0, _react.useContext)(_FormGroupContext.FormGroupContext);
    const [localValue, setLocalValue] = (0, _react.useState)(propsValue !== null && propsValue !== void 0 ? propsValue : false);
    const value = propsValue !== null && propsValue !== void 0 ? propsValue : localValue;
    var _props_id, _props_id1;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "1cc566e8bf9f40ee",
                [
                    colors.border,
                    borderRadius,
                    spacers.s7,
                    spacers.s6,
                    spacers.s6,
                    spacers.s7,
                    isAdmin ? colors.medium : colors.primary,
                    colors.border
                ]
            ]
        ]) + " " + "container"
    }, /*#__PURE__*/ _react.default.createElement("label", {
        htmlFor: (_props_id = props.id) !== null && _props_id !== void 0 ? _props_id : id,
        className: _style.default.dynamic([
            [
                "1cc566e8bf9f40ee",
                [
                    colors.border,
                    borderRadius,
                    spacers.s7,
                    spacers.s6,
                    spacers.s6,
                    spacers.s7,
                    isAdmin ? colors.medium : colors.primary,
                    colors.border
                ]
            ]
        ]) + " " + "row control-row"
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "1cc566e8bf9f40ee",
                [
                    colors.border,
                    borderRadius,
                    spacers.s7,
                    spacers.s6,
                    spacers.s6,
                    spacers.s7,
                    isAdmin ? colors.medium : colors.primary,
                    colors.border
                ]
            ]
        ]) + " " + "control"
    }, /*#__PURE__*/ _react.default.createElement("input", {
        ...inputProps,
        ref: ref,
        id: (_props_id1 = props.id) !== null && _props_id1 !== void 0 ? _props_id1 : id,
        "aria-describedby": hintId,
        type: "checkbox",
        checked: value,
        onChange: (e)=>{
            setLocalValue(e.target.checked);
            if (onChange != null) {
                onChange(e);
            }
        },
        className: _style.default.dynamic([
            [
                "1cc566e8bf9f40ee",
                [
                    colors.border,
                    borderRadius,
                    spacers.s7,
                    spacers.s6,
                    spacers.s6,
                    spacers.s7,
                    isAdmin ? colors.medium : colors.primary,
                    colors.border
                ]
            ]
        ]) + " " + (inputProps && inputProps.className != null && inputProps.className || "")
    })), /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "1cc566e8bf9f40ee",
                [
                    colors.border,
                    borderRadius,
                    spacers.s7,
                    spacers.s6,
                    spacers.s6,
                    spacers.s7,
                    isAdmin ? colors.medium : colors.primary,
                    colors.border
                ]
            ]
        ]) + " " + "info"
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "1cc566e8bf9f40ee",
                [
                    colors.border,
                    borderRadius,
                    spacers.s7,
                    spacers.s6,
                    spacers.s6,
                    spacers.s7,
                    isAdmin ? colors.medium : colors.primary,
                    colors.border
                ]
            ]
        ]) + " " + "label"
    }, label), /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "1cc566e8bf9f40ee",
                [
                    colors.border,
                    borderRadius,
                    spacers.s7,
                    spacers.s6,
                    spacers.s6,
                    spacers.s7,
                    isAdmin ? colors.medium : colors.primary,
                    colors.border
                ]
            ]
        ]) + " " + "description"
    }, description))), value && children != null && children !== false && /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "1cc566e8bf9f40ee",
                [
                    colors.border,
                    borderRadius,
                    spacers.s7,
                    spacers.s6,
                    spacers.s6,
                    spacers.s7,
                    isAdmin ? colors.medium : colors.primary,
                    colors.border
                ]
            ]
        ]) + " " + "row children-row"
    }, children)), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "1cc566e8bf9f40ee",
        dynamic: [
            colors.border,
            borderRadius,
            spacers.s7,
            spacers.s6,
            spacers.s6,
            spacers.s7,
            isAdmin ? colors.medium : colors.primary,
            colors.border
        ]
    }, ".container.__jsx-style-dynamic-selector{display:inline-block;white-space:nowrap;max-width:100%;border:1px solid ".concat(colors.border, ";-webkit-border-radius:").concat(borderRadius, ";-moz-border-radius:").concat(borderRadius, ";border-radius:").concat(borderRadius, "}.row.__jsx-style-dynamic-selector{display:block;padding:").concat(spacers.s7, " ").concat(spacers.s6, "}.control-row.__jsx-style-dynamic-selector{cursor:pointer}.control.__jsx-style-dynamic-selector{display:inline-block;vertical-align:middle}.info.__jsx-style-dynamic-selector{display:inline-block;vertical-align:middle;padding-left:").concat(spacers.s6, ";padding-right:").concat(spacers.s7, "}.label.__jsx-style-dynamic-selector{font-size:16px;line-height:24px;font-weight:600;white-space:normal}.description.__jsx-style-dynamic-selector{font-size:12px;line-height:16px;color:").concat(isAdmin ? colors.medium : colors.primary, ";white-space:normal}.children-row.__jsx-style-dynamic-selector{border-top:1px solid ").concat(colors.border, ";white-space:normal}.form-group:last-child{margin-bottom:0!important}")));
});
FormHeroCheckboxOld.displayName = "FormHeroCheckboxOld";

//# sourceMappingURL=FormHeroCheckboxOld.js.map